/**
 * Returns attributes making interactions with a static/non-interactive element accessible
 * @deprecated
 * @param eventHandlers optional array of events to handle. defaults to only handling onClick
 * @returns
 */
export default function (eventHandlers) {
    if(eventHandlers.onClick) eventHandlers.onKeyDown = filterKeyEnter(eventHandlers.onClick);

    return {
        role: 'button',
        tabIndex: 0,
        ...eventHandlers
    }
}

function filterKeyEnter(handler) {
    return e => {
        if (e.keyCode === 13) handler(e)
    }
}
